import { useContext } from 'react';
import { AssignmentsContext } from './components/Context';
import { ASSIGNMENTS_CONTEXT_ERROR_MESSAGE } from './constants';
import { AssignmentsContextState } from './types';

export const useAssignments = (): AssignmentsContextState => {
  const context = useContext(AssignmentsContext);

  if (context === undefined) {
    throw Error(ASSIGNMENTS_CONTEXT_ERROR_MESSAGE);
  }

  return context;
};
